var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import Page from '../Page';
import { notifyUncaughtErrors } from '../../../utils/errorUtils';
import { getHashParams } from '../../../utils/urlUtils';
import { ApplicationContext } from '../../../ApplicationContext';
import AssetsTable from './AssetsTable';
import AssetsViewState from '../../../data/AssetsViewState';
import Signals from '../../../signals/Signals';
import AssetSignals from './signals/AssetSignals';
import GetOrganisationAssetsCommand from '../../../commands/assets/GetOrganisationAssetsCommand';
import GetOpenServiceEntriesCommand from "../../../commands/services/GetOpenServiceEntriesCommand";
import MapWidget from '../../components/ui/MapWidget/MapWidget';
import withRouter from "../../components/ui/MainNavigation/withRouter";
/**
 *
 */
var Assets = /** @class */ (function (_super) {
    __extends(Assets, _super);
    /**
     *
     */
    function Assets(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: [],
            viewState: AssetsViewState.TABLE,
        };
        _this.onHashChange = _this.onHashChange.bind(_this);
        _this.onAssetDataUpdated = _this.onAssetDataUpdated.bind(_this);
        _this.onAssetDataError = _this.onAssetDataError.bind(_this);
        _this.onOpenServiceEntriesUpdated = _this.onOpenServiceEntriesUpdated.bind(_this);
        _this.updateAssets = _this.updateAssets.bind(_this);
        _this.updateHash = _this.updateHash.bind(_this);
        return _this;
    }
    /**
     *
     */
    Assets.prototype.componentDidMount = function () {
        var _this = this;
        this.updateAssets();
        // AssetSignals.filtersChanged.add(this.updateHash);
        Signals.ChangeAssetViewState.add(function (state) {
            _this.setState({ viewState: state }, function () {
                _this.updateHash();
                if (state != AssetsViewState.TABLE) {
                    Signals.ResizeMap.dispatch();
                }
            });
        });
        //
        Signals.HashChanged.add(this.onHashChange);
        this.onHashChange();
        // Setting an interval for refreshing asset data
        Signals.RefreshAssets.add(this.updateAssets.bind(this));
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    Assets.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    Assets.prototype.componentWillUnmount = function () {
        Signals.HashChanged.remove(this.onHashChange);
        Signals.ChangeAssetViewState.removeAll();
        AssetSignals.filtersChanged.removeAll();
        Signals.RefreshAssets.removeAll();
    };
    /**
     *
     * @returns {*}
     */
    Assets.prototype.render = function () {
        var assetCollection = this.context.assetCollection;
        var viewState = this.state.viewState;
        if (!assetCollection)
            return null;
        var classes = classNames({
            'assets': true
        });
        return (React.createElement(Page, { pageName: classes },
            React.createElement("div", { className: "d-flex h-100" + (viewState === AssetsViewState.MAPVERTICAL ? " flex-column" : " pb-4"), style: { width: "95%" } },
                React.createElement("div", { className: "assets__table-container card mb-0 py-4" + (viewState === AssetsViewState.MAPVERTICAL ? " h-50" : ""), style: { borderRadius: "0 20px 20px 0" } },
                    React.createElement(AssetsTable, { viewState: viewState, assetCollection: assetCollection })),
                viewState === AssetsViewState.TABLE ? null :
                    React.createElement("div", { className: 'assets__map-container pl-4' + (viewState === AssetsViewState.MAPVERTICAL ? " h-50 my-4" : "") },
                        React.createElement("div", { className: "card p-0 overflow-hidden h-100", style: { borderRadius: "20px" } },
                            React.createElement(MapWidget, { className: "h-100" }))))));
    };
    /**
     *
     */
    Assets.prototype.onHashChange = function () {
        var hashParams = getHashParams();
        // Apply view state
        if (hashParams.view) {
            if (hashParams.view === AssetsViewState.MAPVERTICAL) {
                this.setState({ viewState: AssetsViewState.MAPVERTICAL });
            }
            if (hashParams.view === AssetsViewState.MAPHORIZONTAL) {
                this.setState({ viewState: AssetsViewState.MAPHORIZONTAL });
            }
            if (hashParams.view === AssetsViewState.TABLE) {
                this.setState({ viewState: AssetsViewState.TABLE });
            }
        }
    };
    /**
     *
     * @param response
     */
    Assets.prototype.onAssetDataUpdated = function (response) {
        this.updateServiceEntries();
    };
    /**
     *
     * @param response
     */
    Assets.prototype.onOpenServiceEntriesUpdated = function (response) {
        this.updateServiceEntries();
    };
    /**
     *
     * @param error
     */
    Assets.prototype.onAssetDataError = function (error) {
        var intl = this.props.intl;
        Signals.ShowNotification.dispatch(intl.formatMessage({ id: "error.assets.getcommand" }), 'danger', true);
    };
    /**
     *
     */
    Assets.prototype.updateAssets = function () {
        var _this = this;
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection, serviceEntryCollection = _a.serviceEntryCollection;
        var user = session.user;
        if (user) {
            new GetOrganisationAssetsCommand().execute(user.organisation, assetCollection).then(function (response) {
                _this.onAssetDataUpdated(response);
                Signals.AssetsRetrieved.dispatch();
            }).catch(this.onAssetDataError);
            new GetOpenServiceEntriesCommand().execute(user.organisation, serviceEntryCollection).then(this.onOpenServiceEntriesUpdated);
        }
    };
    /**
     * Updates serviceEntries attribute for each assetModel
     */
    Assets.prototype.updateServiceEntries = function () {
        var _a = this.context, assetCollection = _a.assetCollection, serviceEntryCollection = _a.serviceEntryCollection;
        assetCollection.list.forEach(function (assetModel) {
            var assetId = assetModel.getAssetSerial();
            assetModel.serviceEntries = serviceEntryCollection.list.filter(function (serviceEntryModel) { return serviceEntryModel.assetId == assetId; });
        });
    };
    /**
     *
     */
    Assets.prototype.clearUpdateAssets = function () {
        this.context.refreshingTimer.clearInterval();
    };
    /**
     *
     */
    Assets.prototype.updateHash = function () {
        var viewState = this.state.viewState;
        history.pushState(null, null, '#view=' + viewState);
    };
    Assets = __decorate([
        observer
    ], Assets);
    return Assets;
}(React.Component));
Assets.contextType = ApplicationContext;
export default injectIntl(withRouter(Assets));
